import _get from 'lodash/get';
import _cloneDeep from 'lodash/cloneDeep';
import store from '@/store';

const localState = {
  // camelCase
  trail: [],
};

const localGetters = {
  // underscore_lowercase
  trail: state => {
    return state.trail;
  },
};

const localActions = {
  // camelCase
  setTrail({ commit, rootGetters }, route) {
    const breadcrumbs = _cloneDeep(_get(route, 'meta.breadcrumbs', []));
    for (let i = 0; i < breadcrumbs.length; i += 1) {
      const current = breadcrumbs[i].label;
      // NOTE: Jobs use classname 'Report' so we skip translating:
      if (current !== 'Edit' && current !== 'New' && current !== 'Jobs') {
        const className = route.params.classname;
        let customLabel = '';
        customLabel = rootGetters['meta/plural_label'](className);
        if (customLabel === className) {
          const plural = `${className}s`;
          customLabel = rootGetters['translations/rawTranslate'](plural);
          if (customLabel === plural) customLabel = rootGetters['translations/rawTranslate'](className);
        }
        if (customLabel !== className) breadcrumbs[i].customLabel = customLabel;
      }
    }
    commit('set_trail', { route, breadcrumbs });
  },
};

const localMutations = {
  // underscore_case
  /**
   * sets array of navigated routes to be displayed as breadcrumbs
   * @param {Object} state - vuex state object
   * @param {Object} route - object containing data on current route
   * @return {Object[]} array of navigated routes
   */
  set_trail(state, { route, breadcrumbs }) {
    const base_state = [{
      label: 'Welcome',
      route_name: 'welcome',
    }];
    const trails = breadcrumbs.map((crumb) => {
      let label = crumb.label;
      if (!crumb.customLabel && crumb.lookupLabel) {
        const lookup = (key) => {
          if (route.params[key]) return route.params[key];
          if (key === 'classname') {
            const className = route.meta[key];
            const p = store.getters['meta/plural_label'](className);
            if (p) return p;
          }
          if (route.params[key]) return route.params[key];
          return key;
        };
        label = lookup(label);
      }
      return {
        label: crumb.customLabel || label,
        route_name: crumb.name || '',
        disabled: !crumb.name,
        ...(crumb.name === 'search_screen' && { params: { ...(!route.params.classname && { classname: route.meta.classname }) } }),
      };
    });
    const trail = [...base_state, ...trails];
    state.trail = trail;
  },
};

export default {
  namespaced: true,
  state: localState,
  getters: localGetters,
  actions: localActions,
  mutations: localMutations,
};
